// extracted by mini-css-extract-plugin
export default {"overlay":"ModalConfirm_overlay__-7Qrb","window":"ModalConfirm_window__vHJyh","submit":"ModalConfirm_submit__z0m8K"};